import React, {useEffect, useState} from 'react';
import '../style/css/topnav.css'
import IconSend from '../style/icons/send.svg'
import IconMess from '../style/icons/speech-bubble.svg'
import IconTable from '../style/icons/menu.svg'
import IconProfile from '../style/icons/profile-user.svg'
import IconSettings from '../style/icons/settings.svg'
import IconDate from '../style/icons/calendar.svg'
import utils from "../services/utils";
import Modal from "../comps/Modal";
import ConfirmBox from "../comps/ConfirmBox";
import SettingsModal from "./SettingsModal";
import manageareas from "../services/manageareas";
import OrderTable from "./OrderTable";
import ProfileArea from "../comps/ProfileArea";

const TopNavbar = ({setAreaLock,isWorker}) => {
    const [structuredAreas,setStructureAreas] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMessage, setMessage] = useState('')
    const [modalClass,setModalClass] = useState('')

    useEffect(() => {
        if(isWorker) fetchAreas()
    }, []);

    const fetchAreas = async () => {
        try {
            const areasData = await manageareas.getAllArea();
            // Check if deptsData is truthy and ensure it's an array
            if (areasData) {
                let areasArray;
                if (Array.isArray(areasData)) {
                    areasArray = areasData;
                } else if (typeof areasData === 'object' && areasData !== null) {
                    areasArray = [areasData];
                } else {
                    areasArray = []; // Set a default value to avoid breaking the application
                }
                let areasNew = processAreas(areasArray)
                if(areasNew) setStructureAreas(areasNew)
            }
        } catch (error) {
            console.error('Error fetching departments:', error);
        }
    };

    const processAreas = (areas) => {
        const areaMap = {};
        const result = [];
        areas.forEach(area => {
            areaMap[area.ID] = { ...area, subAreas: [] };
        });

        areas.forEach(area => {
            if (area.subToID !== "0") {
                if(areaMap[area.subToID]) areaMap[area.subToID].subAreas.push(areaMap[area.ID]);
            } else {
                result.push(areaMap[area.ID]);
            }
        });
        return result;
    };

    const renderOptions = (areas, prefix = '') => {
        return areas.map(area => (
            <React.Fragment key={area.ID}>
                <option value={area.ID}>
                    {prefix}{area.name} - {prefix ? '' : utils.useLang('ALL')}
                </option>
                {renderOptions(area.subAreas, `${area.name} - `)}
            </React.Fragment>
        ));
    };

    const closeModal = () => {
        setIsModalOpen(false)
    }
    const  handleModalOpen = (type) =>{
        switch (type){
            case 1:
                setMessage(<SettingsModal/>)
                setModalClass('settings-modal-change')
                break;
            case 2:
                setMessage(<OrderTable/>)
                setModalClass('ordertable-modal-change')
                break;
            case 0:
                setMessage(<ProfileArea/>)
                setModalClass('settings-modal-change')
                break;
        }
        setIsModalOpen(true)
    }

    const handleAreaChange = (e) =>{
        setAreaLock(e.target.value)
    }

    return (
        <>
            <div className={'top-nav-container flex'}>
                <div className={'date-container flex ai-c'}>
                    <img className={'date-icon top-nav-icon'} src={IconDate}/>
                    <div className={'day-container flex fd-c'}>
                        <div className={'day'}>יום ראשון</div>
                        <div className={'date'}>21.01.24</div>
                    </div>
                </div>
                <select className={'area-container'} onChange={(e)=>handleAreaChange(e)}>
                    <option value={0}>{utils.useLang('ALL')}</option>
                    {renderOptions(structuredAreas)}
                </select>
                <div className={'top-nav-icons-container flex'}>
                    <img className={'top-nav-icon'} onClick={()=>handleModalOpen(0)} src={IconProfile}/>
                    {isWorker && <img className={'top-nav-icon'} onClick={()=>handleModalOpen(2)} src={IconTable}/>}
                    <img className={'top-nav-icon'} src={IconMess}/>
                {isWorker && <img className={'top-nav-icon send'} src={IconSend}/>}
                {isWorker && <img className={'top-nav-icon'} onClick={()=>handleModalOpen(1)} src={IconSettings}/>}
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={closeModal} modalClass={modalClass}>
                <ConfirmBox message={isMessage} onClose={closeModal} onConfirm={''}/>
            </Modal>
        </>
    );
};

export default TopNavbar;